import React from 'react';

const PdfViewPage = ({ fileUrl }) => (
  <div style={{ width: '100wv', height: '100dvh' }}>
    <embed src={fileUrl} type="application/pdf" width="100%" height="100%" />
  </div>
);

export default PdfViewPage;
